// option-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogOption } from '../../models/dialogoption';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-option-dialog',
  templateUrl: './options-dialog.component.html',
  styleUrl: './options-dialog.component.css',
  imports: [
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    MatListModule,
    CommonModule,
    MatTabsModule,
    MatTooltipModule
  ]
})
export class OptionDialogComponent {

  options: DialogOption[];

  constructor(
    public dialogRef: MatDialogRef<OptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { options: DialogOption[] }
  ) {
    // Initialize options with selection state
    this.options = data.options;

    // Ensure each option has a defined comparison operator (default to greater than = false)
    this.options.forEach(o => {
      if (o.lessThan === undefined || o.lessThan === null) {
        o.lessThan = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(null); // dismiss dialog
  }

  onConfirm(): void {
    const selectedOptions = this.options
      .filter(o => o.selected);
    this.dialogRef.close(selectedOptions);
  }

  onToggle(opt: any): void {
    if (!opt.selected) {
      opt.inputValue = null;
    }
  }

  isFormValid(): boolean {

    let result = true;
    for (const o of this.options) {
      if (o.selected) {
        // input value must be present
        if (o.inputValue === null || o.inputValue === undefined || o.inputValue === '') {
          result = false;
          break;
        }
        // operator must be explicitly boolean
        if (typeof o.lessThan !== 'boolean') {
          result = false;
          break;
        }
      }
    }
    console.log(`form valid: [${result}]`);
    return result;

  }

}
